import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Status } from "../../master-data/master-data.model";
import { NEW_UI_FORM_FIELD_DEFAULTS } from "../../shared/styles/new-ui-form-field";

@Component({
    selector: "app-allowed-statuses-edit",
    templateUrl: "./allowed-statuses-edit.component.html",
    styleUrls: ["./allowed-statuses-edit.component.scss"],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AllowedStatusesEditComponent {
  private formBuilder = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<AllowedStatusesEditComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  form = this.formBuilder.group({
    selectedStatus: [null, [Validators.required]],
  });

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    const status = this.form.value.selectedStatus;
    this.dialogRef.close(status);
  }
}
